import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Container } from "reactstrap";

//Import images
import logo from "../../assets/images/logo-light.svg";
// import NavbarButtons from "../Shared/NavbarButtons";

import { topbarData } from "./topbarData";

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.darkMode = true;
    this.state = topbarData;
  }

  componentDidMount() {
    this.handleThemeSwitch(true);
    var matchingMenuItem = null;
    var ul = document.getElementById("top-menu");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      matchingMenuItem.parentElement.classList.add("active");
    }
  }

  toggleLine = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  }

  handleThemeSwitch = (e) => {
    if (!e) this.darkMode = !this.darkMode;
  }

  render() {
    return (
      <React.Fragment>
        <header id="topnav" className="defaultscroll sticky">
          <Container>
            <div>
              <Link className="logo" to="/index">
                <img src={logo} id="brandLogo" height="50" alt="" />
              </Link>
            </div>
            <div className="buy-button">
              <Link
                to="/contact"
                id="buyButton"
                className="btn btn-primary"
              >
                Contacter
              </Link>
            </div>

            <div className="menu-extras">
              <div className="menu-item">
                <Link
                  to="#"
                  onClick={this.toggleLine}
                  className={
                    this.state.isOpen ? "navbar-toggle open" : "navbar-toggle"
                  }
                >
                  <div className="lines">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </Link>
              </div>
            </div>

            <div
              id="navigation"
              style={{ display: this.state.isOpen ? "block" : "none" }}
            >
              <ul className="navigation-menu" id="top-menu">
                {this.state.navLinks.map((navLink, key) =>
                  <li key={key}>
                    <Link to={navLink.link}>{navLink.title}</Link>
                  </li>
                )}
              </ul>
            </div>
          </Container>
        </header>
      </React.Fragment>
    );
  }
}

export default withRouter(Topbar);
